import { IAuthClient } from "@micro-frontend-react/employee-experience/lib/IAuthClient";
import { IHttpClient } from "@micro-frontend-react/employee-experience/lib/IHttpClient";
import { SagaIterator } from "redux-saga";
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import {} from "../Redux/Reports/action-types";
import {receiveReportList,sendReportListError} from "../Redux/Reports/action";
import { ApiEndpoints ,Messages} from './Constants'
import { ReportsActionType } from "../Redux/Reports/action-types";

function auth(authClient: IAuthClient) {
    return Promise.resolve(authClient.acquireToken(__SCOPES__));
}

//Get list of reports.
export function* requestReportListSagas(): SagaIterator {
    yield all([takeLatest(ReportsActionType.REQUEST_REPORT_LIST, ReportList)]);
}
function* ReportList(): SagaIterator {
    const httpClient: IHttpClient = yield getContext('httpClient');
    const authClient: IAuthClient = yield getContext('authClient');
    try {
        const token = yield call(auth, authClient);
        const result = yield call([httpClient, httpClient.request], {
            url: `${ApiEndpoints.ReportList}`,
            method: 'GET',
            accessToken: token,
        });
        if (result && result.status == 200) {
            yield put(receiveReportList(result.data));
        } else {
            yield put(receiveReportList(null));
            yield put(
                sendReportListError(
                    result.status + ' ' + result.statusText || Messages.ReportList_Error_Message
                )
            );
        }
    } catch (ex) {
        yield put(receiveReportList(null));
        yield put(sendReportListError(Messages.ReportList_Error_Message));
    }
}